// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/videopip-enter.svg';

export const VideoPipEnter = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
